import React, { memo } from 'react';
import { Section } from '../ui/Section';
import { Star } from 'lucide-react';
export function SocialProof() {
  return <Section className="bg-slate-50 border-b border-slate-200" data-id="element-250">
      <div className="container mx-auto px-4" data-id="element-251">
        <div className="text-center mb-8 md:mb-12" data-id="element-252">
          <div className="flex justify-center mb-3 md:mb-4" data-id="element-253">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-5 w-5 md:h-6 md:w-6 text-amber-400 fill-amber-400" data-id="element-254" />)}
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" data-id="element-255">
            Más de 50 médicos ya organizaron su consultorio
          </h2>
          <p className="text-sm md:text-base text-slate-600" data-id="element-256">
            Calificación 4.9/5 • Todo Argentina
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-257">
          {/* Testimonial 1 */}
          <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow hover:-translate-y-1 duration-300" data-id="element-258">
            <p className="text-sm md:text-base text-slate-700 italic mb-4 md:mb-6" data-id="element-259">
              "Antes perdía horas buscando historias clínicas para las juntas
              médicas y no sabía cuántos pacientes habían dejado de venir. Con
              las planillas de seguimiento y el tablero financiero, ahora tengo
              el control total de mi consultorio. Recuperé mi tiempo libre."
            </p>
            <div className="flex items-center gap-3 md:gap-4" data-id="element-260">
              <div className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold text-lg md:text-xl" data-id="element-261">
                M
              </div>
              <div data-id="element-262">
                <p className="font-bold text-slate-900 text-sm md:text-base" data-id="element-263">
                  Dr. Martín S.
                </p>
                <p className="text-xs md:text-sm text-slate-500" data-id="element-264">
                  Oncólogo Clínico, CABA
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow hover:-translate-y-1 duration-300" data-id="element-265">
            <p className="text-sm md:text-base text-slate-700 italic mb-4 md:mb-6" data-id="element-266">
              "El sistema de semáforo para autorizaciones me salvó. Estaba harta
              de pelear por teléfono por medicación demorada. Ahora mi
              secretaria usa el protocolo y sabemos exactamente en qué estado
              está cada trámite sin depender de mi memoria."
            </p>
            <div className="flex items-center gap-3 md:gap-4" data-id="element-267">
              <div className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold text-lg md:text-xl" data-id="element-268">
                L
              </div>
              <div data-id="element-269">
                <p className="font-bold text-slate-900 text-sm md:text-base" data-id="element-270">
                  Dra. Laura G.
                </p>
                <p className="text-xs md:text-sm text-slate-500" data-id="element-271">
                  Oncóloga, Córdoba
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow hover:-translate-y-1 duration-300" data-id="element-272">
            <p className="text-sm md:text-base text-slate-700 italic mb-4 md:mb-6" data-id="element-273">
              "El módulo de facturación es un antes y un después. Facturaba pero
              no sabía si el consultorio era rentable. El Megapack me dio la
              visibilidad financiera que necesitaba para tomar decisiones
              reales, no basadas en sensaciones."
            </p>
            <div className="flex items-center gap-3 md:gap-4" data-id="element-274">
              <div className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold text-lg md:text-xl" data-id="element-275">
                P
              </div>
              <div data-id="element-276">
                <p className="font-bold text-slate-900 text-sm md:text-base" data-id="element-277">
                  Dr. Pablo R.
                </p>
                <p className="text-xs md:text-sm text-slate-500" data-id="element-278">
                  Oncólogo, Rosario
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}